module.exports = __webpack_public_path__ + "static/media/IMG-8749.fc9797f2.JPG";